import React from "react";
import classnames from "classnames";
import "./menu-logo-styles.css";

const MenuLogo = ({ open, cliente }) => {
  const logoSrc = cliente === "ONR"
    ? `${process.env.PUBLIC_URL}/assets/imgs/logo-secundaria-onserp-onr.png`
    : `${process.env.PUBLIC_URL}/assets/imgs/logo-secundaria-solar-bpm.png`;
  const logoAlt = cliente === "ONR" ? "OnSerp" : "Solar BPM";

  return (
    <div className="menu-logo-content">
      <img
        src={logoSrc}
        alt={logoAlt}
        className={classnames("menu-logo-content-img", {
          "menu-logo-content-img-open": open,
        })}
      />
    </div>
  );
};

export default MenuLogo;
